import { http } from 'app/adapters/http/axios';

export class LogoutEndpointService {
  /**
   * Clear out user credential for application sign out.
   * @returns Promise.
   * @throws AxiosError
   */
  public static async clearUserSession() {
    const result = await http.get<unknown>('/j_spring_cas_security_logout');
    return result;
  }
}
